module.exports = "/_next/static/images/main-image-mobile-95e6a9913d2a19ac3ba5473754470bb9.png";